/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Web_Search_SearchInputs */

const es_tools_web_search_search = /** @type {(inputs: Tools_Web_Search_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando en la web...`)
};

const en_tools_web_search_search = /** @type {(inputs: Tools_Web_Search_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching the web...`)
};

/**
* | output |
* | --- |
* | "Searching the web..." |
*
* @param {Tools_Web_Search_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_web_search_search = /** @type {((inputs?: Tools_Web_Search_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Web_Search_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_web_search_search(inputs)
	return en_tools_web_search_search(inputs)
});
export { tools_web_search_search as "tools.web_search.search" }